<template>
  <header class="header desktop-visible" role="navigation" aria-label="Header">
    <button class="skip-btn" @click="$focusOutsidePopup()">Skip to content</button>
    <a v-if="school_website_link && school_website_link.href" :href="school_website_link.href" class="logo-container" target="_blank" :title="$tr(school_website_link.name)"><img class="school-logo" :src="main_logo" alt="School logo"></a>
    <div v-else class="logo-container"><img class="school-logo" :src="main_logo" alt="School Logo"></div>
    <ctas></ctas>
    <navbar :languageDropdownOpen="languageDropdownOpen" @change="onLanguageChange">
      <slot v-if="languages.length > 1">
        <button class="open-translate" @click="languageDropdownOpen = !languageDropdownOpen" aria-label="Possible translation languages">
          <i aria-hidden="true" class="material-icons">translate</i>
          <i aria-hidden="true" class="material-icons" v-if="!languageDropdownOpen">arrow_drop_down</i>
          <i aria-hidden="true" class="material-icons" v-if="languageDropdownOpen">arrow_drop_up</i>
        </button>
      </slot>
    </navbar>
  </header>
</template>

<script>
import CTAs from '@/components/CTAs'
import HeaderNavbar from '@/components/HeaderNavbar'
import { mapState } from 'vuex'

export default {
  name: 'Header',
  components: {
    'ctas': CTAs,
    'navbar': HeaderNavbar
  },
  data () {
    return {
      languageDropdownOpen: false
    }
  },
  methods: {
    onLanguageChange () {
      this.languageDropdownOpen = false
    }
  },
  computed: {
    ...mapState({
      main_logo: state => state.college.settings.main_logo,
      school_website_link: state => state.college.settings.school_website_link,
      languages: state => state.college.languages
    })
  }
}
</script>
